import { Base } from '@studiometa/js-toolkit';
import Panel from './Panel.js';
import Slider from './Slider.js';
import { Action, Tabs } from '@studiometa/ui';
import ZoomedGallery from './ZoomedGallery.js';

/**
 * Popin Newsletter class.
 * @todo refactor and explode structure & component
 */
export default class Product extends Base {
  static config = {
    name: 'Product',
    components: {
        Action,
        Panel,
        Slider,
        Tabs,
        ZoomedGallery
    }
  }
}
